import Message from "./Message";
import React from "react";
import classes from "./Messages.module.css";
import ScrollLTR from "../../../lms-shared/UI/ScrollLTR";

const Messages = ({ filteredlist, deleteMessage, editMessage, duplicateMessage }) => {
    return <div>
        <ScrollLTR dropStyle={{ height: "calc(100vh - 260px)" }}>
            <div className={classes.Messages}>{filteredlist && filteredlist.map(m => <Message
                key={m.id}
                {...m}
                deleteMessage={(e) => deleteMessage(e, m.id)}
                editMessage={() => editMessage(m)}
                duplicateMessage={(e) => duplicateMessage(e, m)}
            ></Message>)}</div>
        </ScrollLTR>
    </div>

}
export default Messages;